/* Wild Thingz theme - global JS (vanilla, no dependencies) */
(function () {
  'use strict';

  var routes = { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartUpdate: '/cart/update.js' };

  /* ---------- Helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function trapOpen(panel, opener) {
    panel.setAttribute('data-open', 'true');
    panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (opener) opener.setAttribute('aria-expanded', 'true');
  }
  function trapClose(panel, opener) {
    panel.setAttribute('data-open', 'false');
    panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (opener) opener.setAttribute('aria-expanded', 'false');
  }

  /* ---------- Mobile nav ---------- */
  var mobileNav = qs('#MobileNav');
  var menuOpenBtns = qsa('[data-menu-open]');
  var menuCloseBtns = qsa('[data-menu-close]');
  menuOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { if (mobileNav) trapOpen(mobileNav, btn); });
  });
  menuCloseBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { if (mobileNav) trapClose(mobileNav, menuOpenBtns[0]); });
  });
  /* Force-close the mobile nav whenever a nav link is clicked, so anchor links to a
     section further down the page (which don't trigger a full page navigation) don't
     leave the drawer open over the newly-scrolled-to content. */
  if (mobileNav) {
    qsa('a', mobileNav).forEach(function (link) {
      link.addEventListener('click', function () { trapClose(mobileNav, menuOpenBtns[0]); });
    });
  }

  /* ---------- Search modal ---------- */
  var searchModal = qs('[data-search-modal]');
  qsa('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!searchModal) return;
      trapOpen(searchModal, btn);
      var input = qs('input[type="search"]', searchModal);
      if (input) input.focus();
    });
  });
  qsa('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { if (searchModal) trapClose(searchModal); });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = qs('#CartDrawer');

  function openCartDrawer() { if (cartDrawer) trapOpen(cartDrawer); }
  function closeCartDrawer() { if (cartDrawer) trapClose(cartDrawer); }

  qsa('[data-cart-open]').forEach(function (btn) { btn.addEventListener('click', openCartDrawer); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) closeCartDrawer();
  });

  function refreshCartDrawer() {
    if (!cartDrawer) return Promise.resolve();
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        if (fresh) {
          cartDrawer.innerHTML = fresh.innerHTML;
          cartDrawer = qs('#CartDrawer');
        }
      })
      .catch(function () {});
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshCartState() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; });
  }

  /* Add to cart (product form) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.product-form');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) btn.setAttribute('disabled', 'disabled');
    var formData = new FormData(form);
    fetch(routes.cartAdd, { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCartState(); })
      .then(function () { return refreshCartDrawer(); })
      .then(function () { openCartDrawer(); })
      .catch(function (err) { console.error(err); })
      .finally(function () { if (btn) btn.removeAttribute('disabled'); });
  });

  /* Quick add (product card) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    btn.setAttribute('disabled', 'disabled');
    fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCartState(); })
      .then(function () { return refreshCartDrawer(); })
      .then(function () { openCartDrawer(); })
      .catch(function (err) { console.error(err); })
      .finally(function () { btn.removeAttribute('disabled'); });
  });

  /* Cart line remove (drawer + page) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    var item = btn.closest('[data-key]');
    var key = item ? item.getAttribute('data-key') : btn.getAttribute('data-key');
    if (!key) return;
    fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCartState(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          return refreshCartDrawer();
        }
      })
      .catch(function (err) { console.error(err); });
  });

  /* Quantity steppers (drawer + product form + cart page) */
  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-quantity-increase], [data-quantity-decrease]');
    if (!stepBtn) return;
    var wrapper = stepBtn.closest('[data-quantity-wrapper]');
    var input = wrapper && wrapper.querySelector('[data-quantity-input]');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var value = parseInt(input.value || '1', 10);
    value = stepBtn.hasAttribute('data-quantity-increase') ? value + 1 : Math.max(min, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-quantity-input]');
    if (!input) return;
    var cartItem = input.closest('[data-cart-item]');
    if (!cartItem) return; // inside a form (e.g. product page) - no AJAX needed here
    var key = cartItem.getAttribute('data-key');
    var qty = Math.max(0, parseInt(input.value || '0', 10));
    fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCartState(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          return refreshCartDrawer();
        }
      })
      .catch(function (err) { console.error(err); });
  });

  /* ---------- Halloween form modal ---------- */
  var hfModal = qs('#HalloweenFormModal');

  function openHfModal() { if (hfModal) trapOpen(hfModal); }
  function closeHfModal() { if (hfModal) trapClose(hfModal); }

  /* Exposed so the section's own inline script can force it open/closed
     while it's selected in the theme editor (shopify:section:select). */
  window.WT_openHalloweenForm = openHfModal;
  window.WT_closeHalloweenForm = closeHfModal;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('a[href$="#halloween-form"], [data-hf-modal-open]');
    if (opener) {
      e.preventDefault();
      openHfModal();
      return;
    }
    if (e.target.closest('[data-hf-modal-close]')) closeHfModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && hfModal && hfModal.getAttribute('data-open') === 'true') closeHfModal();
  });

  /* ---------- Product gallery thumbs ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-media-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var id = thumb.getAttribute('data-media-thumb');
    qsa('[data-media-id]', gallery).forEach(function (el) {
      el.hidden = el.getAttribute('data-media-id') !== id;
      el.classList.toggle('is-active', el.getAttribute('data-media-id') === id);
    });
    qsa('[data-media-thumb]', gallery).forEach(function (el) {
      el.classList.toggle('is-active', el === thumb);
    });
  });

  /* ---------- Header height -> CSS var (anchor-link scroll offset) ---------- */
  var siteHeaderEl = qs('[data-header]');
  if (siteHeaderEl) {
    var setHeaderHeightVar = function () {
      document.documentElement.style.setProperty('--wt-header-h', siteHeaderEl.offsetHeight + 'px');
    };
    setHeaderHeightVar();
    window.addEventListener('load', setHeaderHeightVar);
    window.addEventListener('resize', setHeaderHeightVar);
  }

  /* ---------- Overlay header (homepage hero) ---------- */
  var headerGroup = qs('[data-header-group].site-header-group--overlay');
  if (headerGroup) {
    var headerEl = qs('[data-header]', headerGroup);
    var parsedDelay = headerEl ? parseInt(headerEl.getAttribute('data-scroll-delay'), 10) : NaN;
    var SCROLL_THRESHOLD = isNaN(parsedDelay) ? 10 : parsedDelay;
    var setScrolled = function () {
      headerGroup.classList.toggle('site-header-group--scrolled', window.scrollY > SCROLL_THRESHOLD);
    };
    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true });
  }

  /* ---------- Stockist widget (lazy-loaded on scroll into view) ---------- */
  var stockistLazyEls = qsa('[data-stockist-lazy]');
  if (stockistLazyEls.length) {
    var loadStockist = function (el) {
      if (el.getAttribute('data-stockist-loaded')) return;
      el.setAttribute('data-stockist-loaded', 'true');
      var src = el.getAttribute('data-stockist-src');
      if (!src) return;
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
    };
    if ('IntersectionObserver' in window) {
      var stockistObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadStockist(entry.target);
          stockistObserver.unobserve(entry.target);
        });
      }, { rootMargin: '200px 0px' });
      stockistLazyEls.forEach(function (el) { stockistObserver.observe(el); });
    } else {
      stockistLazyEls.forEach(loadStockist);
    }
  }

  /* ---------- Klaviyo newsletter subscribe (native Shopify customer forms) ----------
     Delegated so it covers both newsletter forms (contact-cta section + footer block)
     without duplicating this per section. These forms post straight to Shopify (full
     page submission), so the Klaviyo call is fired with keepalive so it survives the
     navigation instead of being cancelled - never awaited, never blocks the Shopify
     submission. Same Klaviyo Subscribe API used by the Halloween form
     (sections/halloween-form.liquid), just triggered on native submit instead of
     after a custom AJAX success. */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.matches || !form.matches('form[data-kl-key][data-kl-list]')) return;
    var klKey = form.getAttribute('data-kl-key');
    var klList = form.getAttribute('data-kl-list');
    var emailField = form.querySelector('input[type="email"]');
    var email = emailField ? emailField.value.trim() : '';
    var consentField = form.querySelector('input[name="contact[accepts_marketing]"]');
    var consented = consentField ? consentField.checked : true;
    if (!klKey || !klList || !email || !consented || !window.fetch) return;
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Newsletter signup',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: klList } } }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(klKey), {
      method: 'POST',
      keepalive: true,
      headers: { revision: '2026-07-15', 'Content-Type': 'application/vnd.api+json' },
      body: JSON.stringify(body)
    }).catch(function () {});
  });

  /* ---------- Announcement bar rotation ---------- */
  qsa('[data-announce-autoplay]').forEach(function (bar) {
    var items = qsa('.announce-bar__item', bar);
    if (items.length < 2) return;
    var seconds = parseInt(bar.getAttribute('data-announce-autoplay'), 10) || 5;
    var index = 0;
    setInterval(function () {
      items[index].hidden = true;
      index = (index + 1) % items.length;
      items[index].hidden = false;
    }, seconds * 1000);
  });
})();
